import { render, staticRenderFns } from "./RegisterLoginSettings.vue?vue&type=template&id=6712c54e&scoped=true&"
import script from "./RegisterLoginSettings.vue?vue&type=script&lang=js&"
export * from "./RegisterLoginSettings.vue?vue&type=script&lang=js&"
import style0 from "./RegisterLoginSettings.vue?vue&type=style&index=0&id=6712c54e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6712c54e",
  null
  
)

export default component.exports